import Dialog from '@pelckmans/elementis/components/dialog';
import { ScorableItem } from '../../../api/scorable-items';
import { useTranslation } from 'react-i18next';
import { ReactNode, useContext } from 'react';
import ModalContext from '../../../../../../contexts/ModalContext';
import { MedialinkDialogHeaderTags } from '../../../../components/MedialinkDialogHeaderTags';
import { Node, NodeWithoutDescription } from '../../../../../../api/table-of-content';
import { UserMaterialDialogHeaderTags } from '../../../../components/UserMaterialDialogHeaderTags';
import { Medialink } from '../../../../../../api/medialink';
import { Module } from '../../../../../../api/module';

const TRANSLATION_BASE = 'PAGES.RESULTS.MODALS.SMARTSCHOOL_SKORE_EXPORT';

type Props = {
  id: string;
  medialink?: Medialink;
  scorableItem: ScorableItem;
  selectedModule: Module;
  toc: NodeWithoutDescription[];
  children: ReactNode;
};

function ExportHeader({ id, medialink, scorableItem, selectedModule, toc, children }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const type = t(
    `PAGES.RESULTS.PER_STUDENT.TABLE.SCORABLE_ITEM.TYPE.${scorableItem.isAssignment ? 'ASSIGNMENT' : 'FREE-EXERCISE'}`,
  );

  function renderTags() {
    if (medialink && scorableItem.type === 'medialink') {
      return <MedialinkDialogHeaderTags material={medialink} module={selectedModule} />;
    }

    if (scorableItem.type === 'user-material') {
      return (
        <UserMaterialDialogHeaderTags
          module={selectedModule}
          material={{ ...scorableItem, moduleId: selectedModule.id }}
          isTeacherAlike
          nodes={toc as Node[]}
        />
      );
    }

    return null;
  }

  return (
    <Dialog.Header
      title={t(`${TRANSLATION_BASE}.HEADER.TITLE`, { type, name: scorableItem.name })}
      aria-label={t(`${TRANSLATION_BASE}.HEADER.A11Y_LABEL`)}
      onClose={() => closeModal(id)}
      meta={renderTags()}
    >
      {children}
    </Dialog.Header>
  );
}

export default ExportHeader;
